/**
 * ***IMPORTANT***
 * This entire file is copied from mccauli/node-captions
 * We can't use that module because it uses fs,
 * and we want this module to be compatible with browsers as much as nodejs
 * */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-prototype-builtins */
const mapping = {
  COMMANDS: {
    1020: '',
    1023: '',
    1025: '',
    1026: '',
    1029: '',
    '102a': '',
    '102c': '',
    '102f': '',
    1040: '{break}',
    1042: '',
    1043: '{break}',
    1044: '',
    1045: '{break}',
    1046: '{break}',
    1048: '',
    1049: '{break}',
    '104a': '{break}',
    '104c': '{break}',
    '104e': '{italic}',
    '104f': '{break}{italic}',
    1051: '{break}',
    1052: '{break}',
    1054: '{break}',
    1057: '{break}',
    1058: '{break}',
    '105b': '{break}',
    '105d': '{break}',
    '105e': '{break}',
    '10a1': '',
    '10a2': '',
    '10a4': '',
    '10a7': '',
    '10a8': '',
    '10ab': '',
    '10ad': '',
    '10ae': '',
    '10c1': '{break}',
    '10c2': '{break}',
    '10c4': '{break}',
    '10c7': '{break}',
    '10c8': '{break}',
    '10cb': '{break}',
    '10cd': '{break}',
    '10ce': '{break}{italic}',
    '10d0': '{break}',
    '10d3': '{break}',
    '10d5': '{break}',
    '10d6': '{break}',
    '10d9': '{break}',
    '10da': '{break}',
    '10dc': '{break}',
    '10df': '{break}',
    1142: '',
    1144: '',
    1146: '',
    1148: '',
    '114a': '',
    '114c': '',
    '114e': '{italic}',
    '114f': '',
    1160: '',
    1162: '',
    1164: '',
    1166: '',
    1168: '',
    '116a': '',
    '116c': '',
    '116e': '{italic}',
    '116f': '',
    1240: '',
    1242: '',
    1244: '',
    1246: '',
    1248: '',
    '124a': '',
    '124c': '',
    '124e': '{italic}',
    '124f': '',
    1260: '',
    1262: '',
    1264: '',
    1266: '',
    1268: '',
    '126a': '',
    '126c': '',
    '126e': '{italic}',
    '126f': '',
    1340: '{break}',
    1342: '',
    1343: '{break}',
    1344: '',
    1345: '{break}',
    1346: '{break}',
    1348: '',
    1349: '{break}',
    '134a': '{break}',
    '134c': '{break}',
    '134e': '{italic}',
    '134f': '{break}{italic}',
    1351: '{break}',
    1352: '{break}',
    1354: '{break}',
    1357: '{break}',
    1358: '{break}',
    '135b': '{break}',
    '135d': '{break}',
    '135e': '{break}',
    1360: '',
    1361: '{break}',
    1362: '',
    1364: '{break}',
    1366: '',
    1367: '{break}',
    1368: '{break}',
    '136a': '',
    '136b': '{break}',
    '136c': '',
    '136d': '{break}',
    '136e': '{break}{italic}',
    '136f': '',
    1370: '{break}',
    1373: '{break}',
    1375: '{break}',
    1376: '{break}',
    1379: '{break}',
    '137a': '{break}',
    '137c': '',
    '137f': '{break}',
    '13c1': '{break}',
    '13c2': '{break}',
    '13c4': '{break}',
    '13c7': '{break}',
    '13c8': '{break}',
    '13cb': '{break}',
    '13cd': '{break}',
    '13ce': '{break}{italic}',
    '13d0': '{break}',
    '13d3': '{break}',
    '13d5': '{break}',
    '13d6': '{break}',
    '13d9': '{break}',
    '13da': '{break}',
    '13dc': '{break}',
    '13df': '{break}',
    '13e0': '{break}',
    '13e3': '{break}',
    '13e5': '{break}',
    '13e6': '{break}',
    '13e9': '{break}',
    '13ea': '{break}',
    '13ec': '{break}',
    '13ef': '{break}{italic}',
    '13f1': '{break}',
    '13f2': '{break}',
    '13f4': '{break}',
    '13f7': '{break}',
    '13f8': '{break}',
    '13fb': '{break}',
    '13fc': '{break}',
    '13fd': '{break}',
    '13fe': '{break}',
    1440: '',
    1442: '',
    1444: '',
    1446: '',
    1448: '',
    '144a': '',
    '144c': '',
    '144e': '{italic}',
    '144f': '',
    1460: '',
    1462: '',
    1464: '',
    1466: '',
    1468: '',
    '146a': '',
    '146c': '',
    '146e': '{italic}',
    '146f': '',
    1540: '{break}',
    1542: '',
    1543: '{break}',
    1544: '',
    1545: '{break}',
    1546: '{break}',
    15462: '{break}',
    1548: '',
    1549: '{break}',
    '154a': '{break}',
    '154c': '{break}',
    '154e': '{italic}',
    '154f': '{break}{italic}',
    1551: '{break}',
    1552: '{break}',
    1554: '{break}',
    1557: '{break}',
    1558: '{break}',
    '155b': '{break}',
    '155d': '{break}',
    '155e': '{break}',
    1560: '',
    1561: '{break}',
    1562: '',
    1564: '{break}',
    1566: '',
    1567: '{break}',
    1568: '{break}',
    '156a': '',
    '156b': '{break}',
    '156c': '',
    '156d': '{break}',
    '156e': '{break}{italic}',
    '156f': '',
    1570: '{break}',
    1573: '{break}',
    1575: '{break}',
    1576: '{break}',
    1579: '{break}',
    '157a': '{break}',
    '157c': '',
    '157f': '{break}',
    '15c1': '{break}',
    '15c2': '{break}',
    '15c4': '{break}',
    '15c7': '{break}',
    '15c8': '{break}',
    '15cb': '{break}',
    '15cd': '{break}',
    '15ce': '{break}{italic}',
    '15d0': '{break}',
    '15d3': '{break}',
    '15d5': '{break}',
    '15d6': '{break}',
    '15d9': '{break}',
    '15da': '{break}',
    '15dc': '{break}',
    '15df': '{break}',
    '15e0': '{break}',
    '15e3': '{break}',
    '15e5': '{break}',
    '15e6': '{break}',
    '15e9': '{break}',
    '15ea': '{break}',
    '15ec': '{break}',
    '15ef': '{break}{italic}',
    '15f1': '{break}',
    '15f2': '{break}',
    '15f4': '{break}',
    '15f7': '{break}',
    '15f8': '{break}',
    '15fb': '{break}',
    '15fc': '{break}',
    '15fd': '{break}',
    '15fe': '{break}',
    1640: '{break}',
    1642: '',
    1643: '{break}',
    1644: '',
    1645: '{break}',
    1646: '{break}',
    1648: '',
    1649: '{break}',
    '164a': '{break}',
    '164c': '{break}',
    '164e': '{italic}',
    '164f': '{break}{italic}',
    1651: '{break}',
    1652: '{break}',
    1654: '{break}',
    1657: '{break}',
    1658: '{break}',
    '165b': '{break}',
    '165d': '{break}',
    '165e': '{break}',
    1660: '',
    1661: '{break}',
    1662: '',
    1664: '{break}',
    1666: '',
    1667: '{break}',
    1668: '{break}',
    '166a': '',
    '166b': '{break}',
    '166c': '',
    '166d': '{break}',
    '166e': '{break}{italic}',
    '166f': '',
    1670: '{break}',
    1673: '{break}',
    1675: '{break}',
    1676: '{break}',
    1679: '{break}',
    '167a': '{break}',
    '167c': '',
    '167f': '{break}',
    '16c1': '{break}',
    '16c2': '{break}',
    '16c4': '{break}',
    '16c7': '{break}',
    '16c8': '{break}',
    '16cb': '{break}',
    '16cd': '{break}',
    '16ce': '{break}{italic}',
    '16d0': '{break}',
    '16d3': '{break}',
    '16d5': '{break}',
    '16d6': '{break}',
    '16d9': '{break}',
    '16da': '{break}',
    '16dc': '{break}',
    '16df': '{break}',
    '16e0': '{break}',
    '16e3': '{break}',
    '16e5': '{break}',
    '16e6': '{break}',
    '16e9': '{break}',
    '16ea': '{break}',
    '16ec': '{break}',
    '16ef': '{break}{italic}',
    '16f1': '{break}',
    '16f2': '{break}',
    '16f4': '{break}',
    '16f7': '{break}',
    '16f8': '{break}',
    '16fb': '{break}',
    '16fc': '{break}',
    '16fd': '{break}',
    '16fe': '{break}',
    1740: '',
    1742: '',
    1744: '',
    1746: '',
    1748: '',
    '174a': '',
    '174c': '',
    '174f': '',
    '174e': '{italic}',
    1760: '',
    1762: '',
    1764: '',
    1766: '',
    1768: '',
    '176a': '',
    '176c': '',
    '176e': '{italic}',
    '176f': '',
    9120: '{end-italic}',
    9123: '',
    9125: '',
    9126: '',
    9129: '',
    '912a': '',
    '912c': '',
    '912f': '{italic}',
    9140: '{break}',
    9143: '{break}',
    9145: '{break}',
    9146: '{break}',
    9149: '{break}',
    '914a': '{break}',
    '914c': '{break}',
    '914f': '{break}{italic}',
    9151: '{break}',
    9152: '{break}',
    9154: '{break}',
    9157: '{break}',
    9158: '{break}',
    '915b': '{break}',
    '915d': '{break}',
    '915e': '{break}',
    9161: '{break}',
    9162: '{break}',
    9164: '{break}',
    9167: '{break}',
    9168: '{break}',
    '916b': '{break}',
    '916d': '{break}',
    '916e': '{break}{italic}',
    9170: '{break}',
    9173: '{break}',
    9175: '{break}',
    9176: '{break}',
    9179: '{break}',
    '917a': '{break}',
    '917c': '',
    '917f': '{break}',
    '91a1': '',
    '91a2': '',
    '91a4': '',
    '91a7': '',
    '91a8': '',
    '91ab': '',
    '91ad': '',
    '91ae': '{italic}',
    '91c1': '{break}',
    '91c2': '{break}',
    '91c4': '{break}',
    '91c7': '{break}',
    '91c8': '{break}',
    '91cb': '{break}',
    '91cd': '{break}',
    '91ce': '{break}{italic}',
    '91d0': '{break}',
    '91d3': '{break}',
    '91d5': '{break}',
    '91d6': '{break}',
    '91d9': '{break}',
    '91da': '{break}',
    '91dc': '{break}',
    '91df': '{break}',
    '91e0': '{break}',
    '91e3': '{break}',
    '91e5': '{break}',
    '91e6': '{break}',
    '91e9': '{break}',
    '91ea': '{break}',
    '91ec': '{break}',
    '91ef': '{break}{italic}',
    '91f1': '{break}',
    '91f2': '{break}',
    '91f4': '{break}',
    '91f7': '{break}',
    '91f8': '{break}',
    '91fb': '{break}',
    '91fc': '{break}',
    '91fd': '{break}',
    '91fe': '{break}',
    9240: '{break}',
    9243: '{break}',
    9245: '{break}',
    9246: '{break}',
    9249: '{break}',
    '924a': '{break}',
    '924c': '{break}',
    '924f': '{break}{italic}',
    9251: '{break}',
    9252: '{break}',
    9254: '{break}',
    9257: '{break}',
    9258: '{break}',
    '925b': '{break}',
    '925d': '{break}',
    '925e': '{break}',
    9261: '{break}',
    9262: '{break}',
    9264: '{break}',
    9267: '{break}',
    9268: '{break}',
    '926b': '{break}',
    '926d': '{break}',
    '926e': '{break}{italic}',
    9270: '{break}',
    9273: '{break}',
    9275: '{break}',
    9276: '{break}',
    9279: '{break}',
    '927a': '{break}',
    '927c': '',
    '927f': '{break}',
    '92c1': '{break}',
    '92c2': '{break}',
    '92c4': '{break}',
    '92c7': '{break}',
    '92c8': '{break}',
    '92cb': '{break}',
    '92cd': '{break}',
    '92ce': '{break}{italic}',
    '92d0': '{break}',
    '92d3': '{break}',
    '92d5': '{break}',
    '92d6': '{break}',
    '92d9': '{break}',
    '92da': '{break}',
    '92dc': '{break}',
    '92df': '{break}',
    '92e0': '{break}',
    '92e3': '{break}',
    '92e5': '{break}',
    '92e6': '{break}',
    '92e9': '{break}',
    '92ea': '{break}',
    '92ec': '{break}',
    '92ef': '{break}{italic}',
    '92f1': '{break}',
    '92f2': '{break}',
    '92f4': '{break}',
    '92f7': '{break}',
    '92f8': '{break}',
    '92fb': '{break}',
    '92fc': '{break}',
    '92fd': '{break}',
    '92fe': '{break}',
    9420: '',
    9423: '',
    9425: '',
    9426: '',
    9429: '',
    '942a': '',
    '942c': '',
    '942f': '',
    9440: '{break}',
    9443: '{break}',
    9445: '{break}',
    9446: '{break}',
    9449: '{break}',
    '944a': '{break}',
    '944c': '{break}',
    '944f': '{break}{italic}',
    9451: '{break}',
    9452: '{break}',
    9454: '{break}',
    9457: '{break}',
    9458: '{break}',
    '945b': '{break}',
    '945d': '{break}',
    '945e': '{break}',
    9461: '{break}',
    9462: '{break}',
    9464: '{break}',
    9467: '{break}',
    9468: '{break}',
    '946b': '{break}',
    '946d': '{break}',
    '946e': '{break}{italic}',
    9470: '{break}',
    9473: '{break}',
    9475: '{break}',
    9476: '{break}',
    9479: '{break}',
    '947a': '{break}',
    '947c': '{end-italic}',
    '947f': '{break}',
    '94a1': '',
    '94a2': '',
    '94a4': '',
    '94a7': '',
    '94a8': '',
    '94ab': '',
    '94ad': '',
    '94ae': '',
    '94c1': '{break}',
    '94c2': '{break}',
    '94c4': '{break}',
    '94c7': '{break}',
    '94c8': '{break}',
    '94cb': '{break}',
    '94cd': '{break}',
    '94ce': '{break}{italic}',
    '94d0': '{break}',
    '94d3': '{break}',
    '94d5': '{break}',
    '94d6': '{break}',
    '94d9': '{break}',
    '94da': '{break}',
    '94dc': '{break}',
    '94df': '{break}',
    '94e0': '{break}',
    '94e3': '{break}',
    '94e5': '{break}',
    '94e6': '{break}',
    '94e9': '{break}',
    '94ea': '{break}',
    '94ec': '{break}',
    '94ef': '{break}{italic}',
    '94f1': '{break}',
    '94f2': '{break}',
    '94f4': '{break}',
    '94f7': '{break}',
    '94f8': '{break}',
    '94fb': '{break}',
    '94fc': '{break}',
    '94fd': '{break}',
    '94fe': '{break}',
    9723: '',
    9725: '',
    9726: '',
    9729: '',
    '972a': '',
    '972f': '',
    9740: '{break}',
    9743: '{break}',
    9745: '{break}',
    9746: '{break}',
    9749: '{break}',
    '974a': '{break}',
    '974c': '{break}',
    '974f': '{break}{italic}',
    9751: '{break}',
    9752: '{break}',
    9754: '{break}',
    9757: '{break}',
    9758: '{break}',
    '975b': '{break}',
    '975d': '{break}',
    '975e': '{break}',
    9761: '{break}',
    9762: '{break}',
    9764: '{break}',
    9767: '{break}',
    9768: '{break}',
    '976b': '{break}',
    '976d': '{break}',
    '976e': '{break}{italic}',
    9770: '{break}',
    9773: '{break}',
    9775: '{break}',
    9776: '{break}',
    9779: '{break}',
    '977a': '{break}',
    '977c': '',
    '977f': '{break}',
    '97a1': '',
    '97a2': '',
    '97a4': '',
    '97a7': '',
    '97a8': '',
    '97ad': '',
    '97ae': '',
    '97c1': '{break}',
    '97c2': '{break}',
    '97c4': '{break}',
    '97c7': '{break}',
    '97c8': '{break}',
    '97cb': '{break}',
    '97cd': '{break}',
    '97ce': '{break}{italic}',
    '97d0': '{break}',
    '97d3': '{break}',
    '97d5': '{break}',
    '97d6': '{break}',
    '97d9': '{break}',
    '97da': '{break}',
    '97dc': '{break}',
    '97df': '{break}',
    '97e0': '{break}',
    '97e3': '{break}',
    '97e5': '{break}',
    '97e6': '{break}',
    '97e9': '{break}',
    '97ea': '{break}',
    '97ec': '{break}',
    '97ef': '{break}{italic}',
    '97f1': '{break}',
    '97f2': '{break}',
    '97f4': '{break}',
    '97f7': '{break}',
    '97f8': '{break}',
    '97fb': '{break}',
    '97fc': '{break}',
    '97fd': '{break}',
    '97fe': '{break}',
    1140: '',
  },
  CHARACTERS: {
    20: ' ',
    a1: '!',
    a2: '"',
    23: '#',
    a4: '$',
    25: '%',
    26: '&',
    a7: "'",
    a8: '(',
    29: ')',
    '2a': 'á',
    ab: '+',
    '2c': ',',
    ad: '-',
    ae: '.',
    '2f': '/',
    b0: '0',
    31: '1',
    32: '2',
    b3: '3',
    34: '4',
    b5: '5',
    b6: '6',
    37: '7',
    38: '8',
    b9: '9',
    ba: ':',
    '3b': ';',
    bc: '<',
    '3d': '=',
    '3e': '>',
    bf: '?',
    40: '@',
    c1: 'A',
    c2: 'B',
    43: 'C',
    c4: 'D',
    45: 'E',
    46: 'F',
    c7: 'G',
    c8: 'H',
    49: 'I',
    '4a': 'J',
    cb: 'K',
    '4c': 'L',
    cd: 'M',
    ce: 'N',
    '4f': 'O',
    d0: 'P',
    51: 'Q',
    52: 'R',
    d3: 'S',
    54: 'T',
    d5: 'U',
    d6: 'V',
    57: 'W',
    58: 'X',
    d9: 'Y',
    da: 'Z',
    '5b': '[',
    dc: 'é',
    '5d': ']',
    '5e': 'í',
    df: 'ó',
    e0: 'ú',
    61: 'a',
    62: 'b',
    e3: 'c',
    64: 'd',
    e5: 'e',
    e6: 'f',
    67: 'g',
    68: 'h',
    e9: 'i',
    ea: 'j',
    '6b': 'k',
    ec: 'l',
    '6d': 'm',
    '6e': 'n',
    ef: 'o',
    70: 'p',
    f1: 'q',
    f2: 'r',
    73: 's',
    f4: 't',
    75: 'u',
    76: 'v',
    f7: 'w',
    f8: 'x',
    79: 'y',
    '7a': 'z',
    fb: 'ç',
    '7c': '÷',
    fd: 'Ñ',
    fe: 'ñ',
    '7f': '',
    80: '',
  },
  SPECIAL_CHARS: {
    '91b0': '®',
    9131: '°',
    9132: '½',
    '91b3': '¿',
    '91b4': '™',
    '91b5': '¢',
    '91b6': '£',
    9137: '♪',
    9138: 'à',
    '91b9': ' ',
    '91ba': 'è',
    '913b': 'â',
    '91bc': 'ê',
    '913d': 'î',
    '913e': 'ô',
    '91bf': 'û',
  },
  EXTENDED_CHARS: {
    9220: 'Á',
    '92a1': 'É',
    '92a2': 'Ó',
    9223: 'Ú',
    '92a4': 'Ü',
    9225: 'ü',
    9226: '‘',
    '92a7': '¡',
    '92a8': '*',
    9229: '’',
    '922a': '—',
    '92ab': '©',
    '922c': '℠',
    '92ad': '•',
    '92ae': '“',
    '922f': '”',
    '92b0': 'À',
    9231: 'Â',
    9232: 'Ç',
    '92b3': 'È',
    9234: 'Ê',
    '92b5': 'Ë',
    '92b6': 'ë',
    9237: 'Î',
    9238: 'Ï',
    '92b9': 'ï',
    '92ba': 'Ô',
    '923b': 'Ù',
    '92bc': 'ù',
    '923d': 'Û',
    '923e': '«',
    '92bf': '»',
    1320: 'Ã',
    '13a1': 'ã',
    '13a2': 'Í',
    1323: 'Ì',
    '13a4': 'ì',
    1325: 'Ò',
    1326: 'ò',
    '13a7': 'Õ',
    '13a8': 'õ',
    1329: '{',
    '132a': '}',
    '13ab': '\\',
    '132c': '^',
    '13ad': '_',
    '13ae': '¦',
    '132f': '~',
    '13b0': 'Ä',
    1331: 'ä',
    1332: 'Ö',
    '13b3': 'ö',
    1334: 'ß',
    '13b5': '¥',
    '13b6': '¤',
    1337: '|',
    1338: 'Å',
    '13b9': 'å',
    '13ba': 'Ø',
    '133b': 'ø',
    '13bc': '┌',
    '133d': '┐',
    '133e': '└',
    '13bf': '┘',
  },
};

const SCC_HEADER = 'Scenarist_SCC V1.0';
const SCC_HEADER_REGEX = new RegExp(SCC_HEADER);
const SCC_REGEX_STRING = '([0-9:;]*)([\t]*)((.)*)';
const SCC_REGEX = new RegExp(SCC_REGEX_STRING);
let timeStamp;
let popBuffer = '';
let popOn;
let paintOn;
let paintBuffer = '';
let commandBuffer = [];
let paintTime = '';
let popTime = '';
const paintOnCommands = ['9425', '9426', '94a7'];
let rollUpRows = 0;
let rollRows = [];
let lastCommand;
let frameCount;
let jsonCaptions = [];

function makeCaptionBlock(buffer, startTimeMicro, frames) {
  const cap = {
    startTimeMicro,
    endTimeMicro: undefined,
    frames,
    popOn,
    paintOn,
    rollUpRows,
    commands: commandBuffer.join(' '),
    text: buffer,
  };
  commandBuffer = [];
  buffer = '';
  jsonCaptions.push(cap);
}

function rollUp(clearBuffer) {
  if (rollRows.length >= rollUpRows) {
    rollRows.shift(); // if rows already filled, drop the top one
  } else {
    rollRows.push(paintBuffer);
  }
  if (clearBuffer === true) {
    if (jsonCaptions[jsonCaptions.length - 1] !== undefined && jsonCaptions[jsonCaptions.length - 1].endTimeMicro === undefined) {
      jsonCaptions[jsonCaptions.length - 1].endTimeMicro = paintTime;
    }
    paintBuffer = rollRows.join(' ');
    makeCaptionBlock(paintBuffer, paintTime, frameCount);
    paintBuffer = '';
    rollRows = [];
  }
  if (rollRows.length === rollUpRows) {
    if (jsonCaptions[jsonCaptions.length - 1] !== undefined && jsonCaptions[jsonCaptions.length - 1].endTimeMicro === undefined) {
      jsonCaptions[jsonCaptions.length - 1].endTimeMicro = paintTime;
    }
    paintBuffer = rollRows.join(' ');
    makeCaptionBlock(paintBuffer, paintTime, frameCount);
    paintBuffer = '';
    rollRows = [];
  }
}

function doubleCommand(command) {
  if (command === lastCommand) {
    lastCommand = '';
    return true;
  }
  lastCommand = command;
  return false;
}

module.exports = {
  /**
     * Verifies a SCC file header, returns true/false
     * @function
     * @param {string} header - Header line to verify.
     * @public
     */
  verify(header) {
    return SCC_HEADER_REGEX.test(header.trim());
  },

  /**
     * Converts the SCC file to a proprietary JSON format
     * @function
     * @param {string} data - Entire SCC file content
     * @public
     */
  toJSON(lines) {
    let idx = 0;
    jsonCaptions = [];
    for (idx = 0; idx < lines.length; idx += 1) {
      if (!module.exports.verify(lines[idx])) {
        module.exports.translateLine(lines[idx].toLowerCase());
      }
    }
    if (paintBuffer.length > 0) {
      rollUp(true);
    }
    if (!jsonCaptions[jsonCaptions.length - 1]) {
      throw Error('Failed to convert SCC data');
    }
    if (jsonCaptions[jsonCaptions.length - 1].endTimeMicro === undefined) {
      jsonCaptions[jsonCaptions.length - 1].endTimeMicro = jsonCaptions[jsonCaptions.length - 1].startTimeMicro;
    }
    return jsonCaptions;
  },
  /**
     * translates SCC HEX bits to readable characters based on mappings in config/
     * @function
     * @public
     * @param {string} SCCLine - Entire SCC line
     */
  translateLine(SCCLine) {
    if (SCCLine.length === 0) {
      return;
    }
    let wordIdx;
    const splitLine = SCCLine.match(SCC_REGEX);
    const words = splitLine[3].split(' ');
    // eslint-disable-next-line prefer-destructuring
    timeStamp = splitLine[1];
    frameCount = 0;
    for (wordIdx = 0; wordIdx < words.length; wordIdx += 1) {
      commandBuffer.push(words[wordIdx]);
      module.exports.translateWord(words[wordIdx]);
    }
  },
  translateWord(word) {
    // add frame count
    frameCount += 1;
    // first
    if (mapping.COMMANDS.hasOwnProperty(word)) {
      module.exports.translateCommand(word);
      // second
    } else if (mapping.SPECIAL_CHARS.hasOwnProperty(word)) {
      module.exports.translateSpecialChars(word);
      // third
    } else if (mapping.EXTENDED_CHARS.hasOwnProperty(word)) {
      module.exports.translateExtendedChars(word);
      // fourth
    }
    module.exports.translateCharacters(word);
  },
  translateCommand: function translateCommand(word) {
    const command = word;
    if (doubleCommand(command)) {
      return;
    }
    if (command === '9420') {
      popOn = true;
      paintOn = false;
    } else if (paintOnCommands.indexOf(command) > -1) {
      paintOn = true;
      popOn = false;
      if (command === '9429') {
        rollUpRows = 1;
      } else if (command === '9425') {
        rollUpRows = 2;
      } else if (command === '9426') {
        rollUpRows = 3;
      } else if (command === '94a7') {
        rollUpRows = 4;
      }

      if (paintBuffer.length > 0) {
        // makeCaption
        rollUp(true);
        paintBuffer = '';
      }
      paintTime = module.exports.processTimeStamp(timeStamp, frameCount);
      // something with paint time..
    } else if (command === '94ae') {
      popBuffer = '';
      // clear pop buffer
    } else if (command === '942f' && popBuffer.length > 0) {
      // time
      // make caption
      popTime = module.exports.processTimeStamp(timeStamp, frameCount);
      if (jsonCaptions[jsonCaptions.length - 1] !== undefined && jsonCaptions[jsonCaptions.length - 1].endTimeMicro === undefined) {
        jsonCaptions[jsonCaptions.length - 1].endTimeMicro = popTime;
      }
      makeCaptionBlock(popBuffer, popTime, frameCount);
      popBuffer = '';
    } else if (command === '94ad') {
      // display paint buffer
      if (paintBuffer.length > 0) {
        rollUp(true);
      }
    } else if (command === '942c') {
      rollRows = [];
      if (paintBuffer.length > 0) {
        rollUp(true);
      }
      if (jsonCaptions[jsonCaptions.length - 1] !== undefined && jsonCaptions[jsonCaptions.length - 1].endTimeMicro === undefined) {
        jsonCaptions[jsonCaptions.length - 1].endTimeMicro = module.exports.processTimeStamp(timeStamp, frameCount);
      }
    } else if (paintOn) {
      paintBuffer += mapping.COMMANDS[command];
    } else {
      popBuffer += mapping.COMMANDS[command];
    }
  },
  translateSpecialChars: function translateSpecialChars(word) {
    if (doubleCommand(word)) {
      return;
    }
    if (paintOn) {
      paintBuffer += mapping.SPECIAL_CHARS[word];
    } else {
      popBuffer += mapping.SPECIAL_CHARS[word];
    }
  },
  translateExtendedChars: function translateExtendedChars(word) {
    if (doubleCommand(word)) {
      return;
    }
    if (paintOn) {
      if (paintBuffer.length > 0) {
        paintBuffer = paintBuffer.substring(0, paintBuffer.length - 1);
      }
      paintBuffer += mapping.EXTENDED_CHARS[word];
    } else {
      if (popBuffer.length > 0) {
        popBuffer = popBuffer.substring(0, popBuffer.length - 1);
      }
      popBuffer += mapping.EXTENDED_CHARS[word];
    }
  },
  translateCharacters: function translateCharacters(word) {
    if (word.length > 0) {
      const chars = word.match(/.{1,2}/gi);
      if (mapping.CHARACTERS[chars[0]] === undefined) {
        return;
      }
      if (mapping.CHARACTERS[chars[1]] === undefined) {
        return;
      }
      if (paintOn) {
        paintBuffer += mapping.CHARACTERS[chars[0]];
        paintBuffer += mapping.CHARACTERS[chars[1]];
      } else {
        popBuffer += mapping.CHARACTERS[chars[0]];
        popBuffer += mapping.CHARACTERS[chars[1]];
      }
    }
  },
  processTimeStamp(stampTime, frames) {
    let newFrames;
    const isDropFrame = /;/.test(stampTime); // considered as 'dropframe timebase' where 30FPS is used
    const stamp = stampTime.replace(/;/g, ':').split(':');
    const stampFrames = parseInt(stamp[stamp.length - 1], 10);
    if ((stampFrames + frames) <= 9) {
      newFrames = `0${stampFrames + frames}`;
    } else {
      newFrames = (stampFrames + frames);
    }
    stamp[stamp.length - 1] = newFrames;
    return module.exports.translateTime(stamp.join(':'), isDropFrame);
  },

  /**
     * Converts SCC timestamps to microseconds
     * @function
     * @public
     * @param {string} timeStamp - Timestamp of SCC line
     */
  translateTime(stampTime, isDropFrame) {
    const secondsPerStamp = isDropFrame ? 1 : 1.001;
    const timesplit = stampTime.split(':');
    const timestampSeconds = (parseInt(timesplit[0], 10) * 3600
                + parseInt(timesplit[1], 10) * 60
                + parseInt(timesplit[2], 10)
                + parseInt(timesplit[3], 10) / 30);
    const seconds = timestampSeconds * secondsPerStamp;
    const microSeconds = seconds * 1000 * 1000;
    return (microSeconds > 0) ? microSeconds : 0;
  },
};
